import { ILoginProvider } from "./ILoginProvider";
import { LoginResponse } from "../Model";
import { Pipeline, Request } from "lib/HTTP";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { UrlProvider } from "lib/UrlProvider";
import { BrowserInfo } from "lib/Browser";

export class FacebookNativeLoginProvider implements ILoginProvider {
    getName = () => "FacebookNativeLoginProvider";

    static async init() {
        await SocialLogin.initialize({
            facebook: {
                appId: '923660191078690',
                clientToken: 'linkstacks',
            },
        });
    }

    async login(): Promise<LoginResponse> {
        const result = await SocialLogin.login({
            provider: 'facebook',
            options: {
                permissions: ['email', 'public_profile'],
            },
        });

        const accessToken = result?.result?.accessToken?.token;

        if (!accessToken) {
            alert("Sorry, login did not provide a usable response. Please try again.");
            return;
        }

        const response = await new Pipeline().fetch(`${new UrlProvider().root}/api/external-login/facebook`, new Request().setJSON({ token: accessToken }));
        return await response.json() as LoginResponse;
    }
}

if (BrowserInfo.isApp()) {
    try {
        FacebookNativeLoginProvider.init();
    } catch (error) {
        console.log("Unable to initialize facebook login provider", error);
    }
}


